import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components/src/styles';

export const contentWrapper = css`
  display: flex;
  height: 100%;
  justify-items: space-between;
`;

export const leftSideWrapper = css`
  padding: 25px 30px 25px 30px;
  width: 548px;
`;

export const headerMargin = css`
  margin-bottom: 5px;
  width: 470px;
  > :first-child {
    margin-bottom: 10px;
  }
`;

export const headerIconLine = css`
  display: flex;
  gap: 5px;
  > svg {
    color: ${colors.primary.default};
    width: ${icons.size.small};
    height: ${icons.size.small};
  }
`;

export const rightSideWrapper = css`
  width: 352px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.custom.lightestGray50};
`;

export const contentGroup = css`
  margin-top: 25px;

  > :nth-child(2) {
    width: 95%;
    margin: 0 auto;
  }
`;

export const contentSection = css`
  padding: 20px;
  border-radius: 5px;
  display: flex;
  align-items: flex-start;
  background: ${colors.custom.lightestGray50};

  > :nth-child(1) {
    flex-grow: 1;
    flex-basis: 35%;
  }

  > :nth-child(2) {
    flex-grow: 1;
    flex-basis: 35%;

    > :nth-child(3) {
      margin-left: 24px;
      display: block;
    }
  }

  > :nth-child(3) {
    flex-grow: 1;
    flex-basis: 30%;

    > :nth-child(3) {
      margin-left: 24px;
      display: block;
    }
  }
`;

export const textSummaryIcon = css`
  margin-right: 6px;
  color: ${colors.gray.dark};
  width: ${icons.size.small};
  height: ${icons.size.small};
`;

export const checkbox = css`
  margin-top: 40px;
`;
